import { AppPaths } from '@ftr/routing-paths'
import { SideNavGroup } from './side-nav-item'

export const PLANS_NAV_GROUP: SideNavGroup = {
  title: 'Plans',
  items: [
    {
      type: 'LINK',
      icon: 'DollarSign',
      title: 'Pricing',
      path: [`/${AppPaths.NotFound}`],
    },
  ],
}
